module.exports = __webpack_public_path__ + "static/media/I16.22cd4fd0.png";